var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-box-wrapper"},[_c('div',{staticClass:"chart-box"},[_c('div',{class:'apexchart-' + _vm.chart.name})])])}
var staticRenderFns = []

export { render, staticRenderFns }